import { useDeviceScreenWidthInterval } from "./useDeviceScreenWidthInterval";

export const useDeviceScreenWidth = (width: number) => {
  const isSmallScreen = useDeviceScreenWidthInterval(0, width);
  return isSmallScreen;
};
